export const paths = {
  home: '/',
  howItWorks: '/how-it-works',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms-and-conditions',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  contact: '/contact-us',
  aboutUs: '/about-us',
  blog: '/blog',
  features: '/features',
  forRestaurants: '/for-restaurants',
  forSuppliers: '/for-suppliers',
  faq: '/faq',
  page404: '/404',
};
